import IDataFilterDescriptor from "../IDataFilterDescriptor";
import IDataFilterSelectInputBoxCurrencyHandler from "./IDataFilterSelectInputBoxCurrencyHandler";
import IDataFilterSelectInputValue from "../selectBox/IDataFilterSelectInputValue";

export default class DataFilterSelectInputBoxCurrencyHandler implements IDataFilterSelectInputBoxCurrencyHandler {
   
    setDescriptorValuesFromUrlParams(descriptor: IDataFilterDescriptor, urlParams: URLSearchParams): void {        
        (descriptor.value as IDataFilterSelectInputValue).value = urlParams.get(descriptor.name) ?? "";
    }

    setDescriptorValuesToUrlParams(descriptor: IDataFilterDescriptor, urlParams: URLSearchParams): void {
        const selectInputCurrencyValue = descriptor.value as IDataFilterSelectInputValue;
        if (selectInputCurrencyValue.value) {
            urlParams.set(descriptor.name, selectInputCurrencyValue.value);
        } else {
            urlParams.delete(descriptor.name);
        }
    }
}